import Table from 'admin/components/atoms/Table';
import Pager from 'admin/components/shared/Pager';
import React from 'react';
import { Link } from 'react-router-dom';
import { getOrganizationApplications } from '~/javascripts/admin/actions/merchant-applications';
import { formatJstFromUtc } from '~/javascripts/admin/utils';
import { createBadge } from '../../../atoms/Badge';

type GetOrganizationApplicationsResponse = Awaited<ReturnType<typeof getOrganizationApplications>>;

type Props = {
  applications: GetOrganizationApplicationsResponse['rows'];
  pagination?: GetOrganizationApplicationsResponse['pagination'];
  onChangePage: (page: number) => void;
};

const StatusBadge = createBadge({
  submitted: {
    bgColor: '#3a65e8',
    color: 'white',
    label: '申請受付済',
  },
  reviewing: {
    bgColor: '#E8890C',
    color: 'white',
    label: '審査中',
  },
  pending: {
    bgColor: '#9A6700',
    color: 'white',
    label: '保留中',
  },
  approved: {
    bgColor: '#21BF25',
    color: 'white',
    label: '申請承認済',
  },
  rejected: {
    bgColor: '#525252',
    color: 'white',
    label: '却下',
  },
});

const ListTable = ({ applications, pagination, onChangePage }: Props) => {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.Cell size="2">進捗状態</Table.Cell>
          <Table.Cell size="2">申請番号</Table.Cell>
          <Table.Cell size="2">申請受付日</Table.Cell>
          <Table.Cell size="2">申請者</Table.Cell>
          <Table.Cell size="2">組織名</Table.Cell>
          <Table.Cell size="2">氏名</Table.Cell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {applications?.map((application) => (
          <Table.Row
            key={application.id}
            styles={{
              background: application.status === 'rejected' ? '#ddd' : 'unset',
            }}
          >
            <Table.Cell>
              <StatusBadge status={application.status} />
            </Table.Cell>
            <Table.Cell>
              <Link to={`/organizations/application/${application.id}`}>
                {application.id.substring(0, 8).toUpperCase()}
              </Link>
            </Table.Cell>
            <Table.Cell>{formatJstFromUtc(application.applied_at, '-')}</Table.Cell>
            <Table.Cell>{application.submitted_by_admin_user?.name ?? '申込フォーム'}</Table.Cell>
            <Table.Cell>{application.name}</Table.Cell>
            <Table.Cell>{application.representative_name ?? '-'}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      <Table.Footer>
        <Table.Row noBorder>
          <Table.Cell colSpan="6" align="center" styles={{ paddingTop: '16px' }}>
            <Pager pagination={pagination} onChangePage={onChangePage} />
          </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default ListTable;
